import React, { useState, useEffect, useContext, useRef } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  ActivityIndicator,
  ScrollView,
  Dimensions,
  PixelRatio,
  Modal,
} from "react-native";
import { MaterialCommunityIcons } from "@expo/vector-icons";

// Custom Utilities, Contexts, and Hooks
import Colours from "../../utils/Colours";
import AppContext from "../../context/AppContext";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import socketConfig from "../../utils/socketConfig";
import useAuth from "../../hooks/useAuth";
import ErrorAlertComp from "../../alertComp/ErrorAlertComp";
import { useNavigation, useNavigationContainerRef, useRoute } from "@react-navigation/native";
import { SafeAreaView } from "react-native-safe-area-context";

const { width, height } = Dimensions.get("window");
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

const dynamicFontSize = (size) => {
  const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
  return Math.round(PixelRatio.roundToNearestPixel(size * scaleFactor));
};
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const PayForTable = () => {
  const route = useRoute();
  const navigation = useNavigation();

  // 1. Read individual primitive identifiers directly from the URL route safely
  const { auth, setAuth } = useContext(AppContext);
  const { email, sub, firstname } = useAuth();
  const axiosPrivate = useAxiosPrivate();

  const [loading, setLoading] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const [isPayAgain, setIsPayAgain] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isErrorCompVisible, setIsErrorCompVisible] = useState(false);
  const [paymentFailed, setPaymentFailed] = useState(false);
  const [transactionReference, setTransactionReference] = useState(
    auth?.pendingOrderDetails?.reference,
  );
  const hasAutoLaunched = useRef(false);

  // --- EXTRACT RENDER PARAMS DIRECTLY FROM UNIFIED BACKEND SCHEMAS ---
  const amount = auth?.pendingOrderDetails?.amount || 0;
  // const transactionReference = auth?.pendingOrderDetails?.reference;
  const tableId = auth?.pendingOrderDetails?.tableId;
  const processedItems = auth?.pendingOrderDetails?.items || [];
  const tableAnonymity = auth?.pendingOrderDetails?.tableAnonymity;
  const isReserved = auth?.pendingOrderDetails?.isReserved;
  const showId = auth?.pendingOrderDetails?.showId;

  console.log("isReserveddd", isReserved);

  const isFromChooseSpend = route?.params?.fromChooseSpend || auth?.fromChooseSpend;

  const navigationRef = useNavigationContainerRef();

  // const MONNIFY_CONTRACT_CODE = "0148073890";
  // const MONNIFY_API_KEY = "MK_TEST_WRHB7Z3JZZ";

  const MONNIFY_API_KEY = "MK_PROD_CH172AQ3QC";
  const MONNIFY_CONTRACT_CODE = "978171905261";

  // Extract the reference from your stored checkoutUrl or backend payload
  // const transactionReference = checkoutUrl
  //   ? new URL(checkoutUrl).searchParams.get("reference")
  //   : null;

  console.log("Debug System -> reference checked:", transactionReference);

  // --- REUSABLE ROUTING ROUTINE ---
  const handleSuccessRedirection = () => {
    // Clear auth context immediately so this modal unmounts/closes automatically
    setAuth((prev) => ({
      ...prev,
      hasPendingPrepaidOrder: false,
      pendingOrderDetails: null,
    }));

    // // Perform your frontend path checks
    // const currentPath = window.location.pathname;
    // const validPaths = ["/home", "/Home", "/main"];
    // window.location.href = validPaths.includes(currentPath) ? currentPath : "/home";
  };

  //  NEW: REAL-TIME WEBHOOK-SUCCESS POLLER
  // This automatically runs in the background. Once your backend webhook
  // updates the User database record (which sets hasPendingPrepaidOrder to false),
  // this hook intercepts it and closes the Monnify checkout UI automatically.

  // useEffect(() => {
  //   let intervalId;

  //   if (auth?.hasPendingPrepaidOrder) {
  //     intervalId = setInterval(async () => {
  //       try {
  //         const response = await axiosPrivate.get("/payments2/pingUser");

  //         if (response.data?.hasPendingPrepaidOrder === false) {
  //           console.log("Poller: webhook confirmed payment. Cleaning up UI...");
  //           clearInterval(intervalId);

  //           // Remove whatever Monnify actually injected — verify these selectors
  //           // in devtools while the modal is open (Elements tab, search "monnify")
  //           document
  //             .querySelectorAll('iframe[src*="monnify"], [id*="monnify"], [class*="monnify"]')
  //             .forEach((el) => el.remove());

  //           document.body.style.overflow = "auto";

  //           setLoading(false);
  //           setIsPayAgain(false);
  //           handleSuccessRedirection();
  //         }
  //       } catch (err) {
  //         console.warn("Polling error checking payment status:", err);
  //       }
  //     }, 3000);
  //   }

  //   return () => {
  //     if (intervalId) clearInterval(intervalId);
  //   };
  // }, [auth?.hasPendingPrepaidOrder]);

  // --- MONNIFY MODAL SDK TRIGGER ---

  const triggerMonnifySDK = async (isRetry = false) => {
    console.log("transactionReferenceff", transactionReference);
    console.log("!window.MonnifySDK", !window.MonnifySDK);

    if (typeof window === "undefined" || !window.MonnifySDK) {
      console.error("Monnify SDK script not loaded.");
      return;
    }

    if (isRetry) setIsPayAgain(true);
    setLoading(true);

    let refToUse = transactionReference;

    // 🌟 On retry, get a FRESH reference instead of reusing the stale one.
    if (isRetry) {
      try {
        const res = await axiosPrivate.post("/payments2/initialize-checkout", {
          tableId,
          items: processedItems,
          showId: showId,
          tableAnonymity,
          // phoneNumber: whatsappNumber, // Folded in from local configuration input
        });

        if (res.data.status === "success") {
          refToUse = res.data?.data?.reference;
          setTransactionReference(refToUse);
          setAuth((prev) => ({
            ...prev,
            isProfileComplete: true,
            hasPendingPrepaidOrder: res.data?.hasPendingPrepaidOrder,
            pendingOrderDetails: res.data?.pendingOrderDetails,
            reference: res.data?.data?.reference,
          }));
        }
      } catch (err) {
        //console.error("Failed to generate a new payment reference:", err);
        setLoading(false);
        setIsPayAgain(false);
        setErrorMessage("Failed to complete new transaction");
        setIsErrorCompVisible(true);
        return;
      }
    }

    if (!refToUse) {
      console.error("Monnify SDK script not loaded or reference missing.");
      setLoading(false);
      return;
    }

    const customerEmail = email || "checkout@getmeeza.com";
    const customerName = `${firstname}`.trim();

    console.log("email", customerEmail, "firstname", customerName);

    // window.MonnifySDK.initialize({
    //   apiKey: MONNIFY_API_KEY, // Replace with your key
    //   contractCode: MONNIFY_CONTRACT_CODE, // Replace with your contract code
    //   amount: amount, // Pass the total billing numerical amount here too!
    //   currency: "NGN",
    //   customerName: customerName,
    //   customerEmail: customerEmail,
    //   // paymentDescription: `Prepaid Table Order ${tableId}`,
    //   paymentDescription: `Prepaid Table Order`,
    //   transactionReference: transactionReference,
    //   isTestMode: true, // Set to false in production

    //   metaData: {
    //     tableId: tableId,
    //     userId: sub,
    //     items: processedItems, // Passed smoothly as clean arrays
    //   },

    //   onComplete: function (paymentResponse) {
    //     setLoading(false);
    //     setIsPayAgain(false);

    //     if (paymentResponse.paymentStatus === "PAID") {
    //       console.log("Payment successful inside inline modal framework!");
    //       handleSuccessRedirection();
    //     } else {
    //       setPaymentFailed(true);
    //     }
    //   },
    //   onClose: function (data) {
    //     setLoading(false);
    //     setIsPayAgain(false);
    //     console.log("User manually dismissed the payment overlay module.", data);
    //   },
    // });

    window.MonnifySDK.initialize({
      // apiKey: "MK_TEST_WRHB7Z3JZZ", // Your active public sandbox key
      apiKey: MONNIFY_API_KEY,
      contractCode: MONNIFY_CONTRACT_CODE,

      // 🌟 CRITICAL SDK PARAMETER NAMES
      reference: refToUse, //transactionReference,
      amount: Number(amount),
      currency: "NGN",
      paymentDescription: "Prepaid Table Order Payment",

      customerName: customerName,
      customerEmail: customerEmail,
      isTestMode: false,

      // paymentMethods: ["ACCOUNT_TRANSFER"],
      paymentMethods: ["ACCOUNT_TRANSFER"],

      metaData: {
        tableId: tableId,
        userId: auth?.user?._id || auth?.userId,
      },

      onLoadStart: () => {
        console.log("Monnify payment UI loading...");
        setLoading(true); // shows the ActivityIndicator (see render snippet below)
      },
      onLoadComplete: () => {
        console.log("Monnify SDK ready.");
        setLoading(false); // hides it once the real modal is ready to interact with
      },

      onComplete: function (paymentResponse) {
        console.log("Testing onComplete");
        try {
          setLoading(false);
          setIsPayAgain(false);

          if (paymentResponse.paymentStatus === "PAID") {
            console.log("SDK Payment Success Modal Event.");
            handleSuccessRedirection();
          } else {
            setPaymentFailed(true);
          }
        } catch (err) {
          console.error("Error inside Monnify onComplete handler:", err);
        }
      },
      onClose: function (data) {
        setLoading(false);
        setIsPayAgain(false);
        console.log("Checkout frame dismissed manually by consumer.", data);
      },
    });
  };

  /***REINSTATE BEFOR PRODUCTION */
  useEffect(() => {
    // if (transactionReference && !hasAutoLaunched.current) {
    if (transactionReference && !hasAutoLaunched.current && !isFromChooseSpend) {
      hasAutoLaunched.current = true;
      triggerMonnifySDK();
    }
  }, [transactionReference]);

  // // 2. Global WebSocket Listener fallback (for double insurance sync)
  // // useEffect(() => {
  // //   // Assuming your global socket connection is accessible or managed here
  // //   if (typeof window === "undefined") return;

  // //   // If your app utilizes a global ws hook or instance, reference it here. Example:
  // //   const handleWsMessage = (event) => {
  // //     const msg = JSON.parse(event.data);
  // //     if (msg.type === "PAYMENT_SUCCESSFUL") {
  // //       console.log("WebSocket engine confirmed order completion.");
  // //       handleSuccessRedirection();
  // //     }
  // //   };

  // //   // Replace with your real app socket connection reference if necessary
  // //   window.addEventListener("message", handleWsMessage);
  // //   return () => window.removeEventListener("message", handleWsMessage);
  // // }, []);

  // // 3. Handle Cancel and Manual Database Cleanup
  // const handleClose = async () => {
  //   setIsClosing(true);
  //   setLoading(true);

  //   try {
  //     await axiosPrivate.post("cancelPendingOrders/cancelPendingOrders");
  //     console.log("Database successfully reset for pending order.");
  //   } catch (error) {
  //     console.error("Failed to reset pending order in the database:", error);
  //   } finally {
  //     setAuth((prev) => ({
  //       ...prev,
  //       hasPendingPrepaidOrder: false,
  //       pendingOrderDetails: null,
  //     }));
  //     setLoading(false);
  //   }
  // };

  const handleClose = async () => {
    setIsClosing(true);
    setLoading(true);

    try {
      await axiosPrivate.post("cancelPendingOrders/cancelPendingOrders");

      console.log("Database successfully reset for pending order.");

      // setAuth((prev) => ({
      //   ...prev,
      //   hasPendingPrepaidOrder: false,
      //   pendingOrderDetails: null,
      // }));
      const routeNames = navigation.getState()?.routeNames || [];

      const homeRoute = routeNames.includes("main") ? "main" : "Home";

      navigation.reset({
        index: 0,
        routes: [{ name: homeRoute }],
      });

      setAuth((prev) => ({
        ...prev,
        hasPendingPrepaidOrder: false,
        pendingOrderDetails: null,
      }));
    } catch (error) {
      console.error("Failed to reset pending order in the database:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleRevisitMenu = () => {
    navigation.navigate("revisitChoose", {
      tableId: tableId,
      // flexTier: selectedFlex,
      // tableAnonymity: isAnonymous,
      // isTopUp: isTopUp,
    });
  };

  const isActionDisabled = !amount || amount <= 0;

  return (
    <SafeAreaView style={styles.container}>
      {/* HEADER */}
      <View style={styles.header}>
        <Text style={styles.headerTitle}>Secure Checkout</Text>
      </View>

      <ScrollView contentContainerStyle={styles.scrollContent}>
        {/* BILLING SUMMARY CARD */}
        <View style={styles.summaryCard}>
          <View style={styles.row}>
            <Text style={styles.label}>Order Amount</Text>
            <Text style={styles.value}>₦{amount.toLocaleString()}</Text>
          </View>

          <View style={styles.row}>
            <Text style={styles.label}>Service Charge</Text>
            <Text style={styles.value}>₦0.00</Text>
          </View>

          <View style={[styles.row, { marginTop: 10 }]}>
            <Text style={styles.totalLabel}>Total to Pay</Text>
            <Text style={styles.totalValue}>₦{amount.toLocaleString()}</Text>
          </View>
        </View>

        {/* INFO NOTICE */}
        <View style={styles.infoBox}>
          <MaterialCommunityIcons name="shield-check" size={20} color={Colours.PRIMARY} />
          <Text style={styles.infoText}>
            Your payment is secured by Monnify by Moniepoint and Paystack our payment processing
            partners.
          </Text>
        </View>

        {paymentFailed && !loading && (
          <Text style={styles.returnNotice}>
            Transaction was uncompleted. Would you like to retry or cancel?
          </Text>
        )}
      </ScrollView>

      {/* FOOTER CONTROLS */}
      <View style={styles.footer}>
        {loading ? (
          <View style={styles.loaderContainer}>
            <ActivityIndicator size="large" color={Colours.PRIMARY} />
            <Text style={styles.loaderText}>
              {isPayAgain
                ? "Connecting to payment gateway..."
                : isClosing
                  ? "Canceling..."
                  : "Awaiting payment window initialization..."}
            </Text>
          </View>
        ) : (
          <View style={styles.actionBlock}>
            {/* Primary Pay Button */}
            {/* <TouchableOpacity style={styles.payBtn} onPress={() => triggerMonnifySDK(true)}>
              <Text style={styles.payBtnText}>Pay Exactly ₦{amount.toLocaleString()}</Text>
              <MaterialCommunityIcons name="lock-outline" size={20} color="white" />
            </TouchableOpacity> */}
            <TouchableOpacity
              style={[styles.payBtn, isActionDisabled && styles.disabledBtn]}
              onPress={() => !isActionDisabled && triggerMonnifySDK(true)}
              disabled={isActionDisabled}
              activeOpacity={isActionDisabled ? 1 : 0.7}
            >
              <Text style={[styles.payBtnText, isActionDisabled && styles.disabledText]}>
                Pay Exactly ₦{amount ? amount.toLocaleString() : "0"}
              </Text>
              <MaterialCommunityIcons
                name="lock-outline"
                size={20}
                color={isActionDisabled ? "#A0A0A0" : "white"}
              />
            </TouchableOpacity>

            {/* Revisit Menu Button - Hidden for Reserved Orders */}
            {/* {!isReserved && (
             
              

              <TouchableOpacity
                style={[styles.revisitBtn, isActionDisabled && styles.disabledRevisitBtn]}
                onPress={() => !isActionDisabled && handleRevisitMenu()}
                disabled={isActionDisabled}
                activeOpacity={isActionDisabled ? 1 : 0.7}
              >
                <Text
                  style={[styles.revisitBtnText, isActionDisabled && styles.disabledRevisitText]}
                >
                  Revisit Menu
                </Text>
                <MaterialCommunityIcons
                  name="silverware-fork-knife"
                  size={20}
                  color={isActionDisabled ? "#A0A0A0" : Colours.PRIMARY}
                />
              </TouchableOpacity>

              
            )} */}

            {/* Cancel & Close Button */}
            <TouchableOpacity style={styles.closeBtn} onPress={handleClose}>
              <Text style={styles.closeBtnText}>Cancel & Close</Text>
              <MaterialCommunityIcons name="close-circle-outline" size={20} color="#E53935" />
            </TouchableOpacity>
          </View>
        )}
      </View>

      <Modal visible={isErrorCompVisible} transparent animationType="fade">
        <ErrorAlertComp
          message={errorMessage}
          onClose={() => {
            // setCart({});
            setIsErrorCompVisible(false);
          }}
        />
      </Modal>
    </SafeAreaView>
  );
};

export default PayForTable;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colours.LIGHTEST,
  },
  header: {
    alignItems: "center",
    paddingHorizontal: dynamicSpacing(20),
    paddingVertical: dynamicSpacing(15),
  },
  headerTitle: {
    fontSize: dynamicFontSize(18),
    fontFamily: "Sen-Bold",
    color: Colours.DARKGRAY,
  },
  scrollContent: {
    paddingHorizontal: dynamicSpacing(20),
    paddingTop: dynamicSpacing(10),
  },
  summaryCard: {
    backgroundColor: "white",
    borderRadius: dynamicSize(24),
    padding: dynamicSpacing(25),
    borderWidth: 1,
    borderColor: "#F2F2F2",
  },
  row: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: dynamicSpacing(12),
  },
  label: {
    fontSize: dynamicFontSize(14),
    fontFamily: "Sen-Regular",
    color: Colours.DARKLIGHTGRAY,
  },
  value: {
    fontSize: dynamicFontSize(14),
    fontFamily: "Sen-Bold",
    color: Colours.DARKGRAY,
  },
  totalLabel: {
    fontSize: dynamicFontSize(16),
    fontFamily: "Sen-Bold",
    color: Colours.DARKGRAY,
  },
  totalValue: {
    fontSize: dynamicFontSize(20),
    fontFamily: "Sen-Bold",
    color: Colours.PRIMARY,
  },
  infoBox: {
    flexDirection: "row",
    backgroundColor: "#F0F7FF",
    padding: dynamicSpacing(15),
    borderRadius: dynamicSize(15),
    marginTop: dynamicSpacing(25),
    alignItems: "center",
  },
  infoText: {
    flex: 1,
    fontSize: dynamicFontSize(12),
    fontFamily: "Sen-Regular",
    color: "#4A6E91",
    marginLeft: 10,
    lineHeight: 18,
  },
  returnNotice: {
    color: "#777",
    fontSize: dynamicFontSize(13),
    fontFamily: "Sen-Regular",
    textAlign: "center",
    marginTop: dynamicSpacing(25),
    paddingHorizontal: 10,
  },
  footer: {
    padding: dynamicSpacing(20),
    backgroundColor: "white",
    borderTopWidth: 1,
    borderTopColor: "#F2F2F2",
  },
  loaderContainer: {
    alignItems: "center",
    paddingVertical: 10,
  },
  loaderText: {
    marginTop: 10,
    color: Colours.DARKGRAY,
    fontFamily: "Sen-Medium",
    fontSize: dynamicFontSize(14),
  },
  actionBlock: {
    gap: 12,
  },
  payBtn: {
    backgroundColor: Colours.PRIMARY,
    height: dynamicSize(55),
    borderRadius: dynamicSize(14),
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: 8,
  },
  payBtnText: {
    color: "white",
    fontSize: dynamicFontSize(15),
    fontFamily: "Sen-Bold",
  },
  revisitBtn: {
    backgroundColor: Colours.PRIMARY_LIGHTER,
    height: dynamicSize(55),
    borderRadius: dynamicSize(14),
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    borderWidth: 1,
    borderColor: Colours.PRIMARY,
    gap: 8,
  },
  revisitBtnText: {
    color: Colours.PRIMARY,
    fontSize: dynamicFontSize(15),
    fontFamily: "Sen-Bold",
  },
  closeBtn: {
    backgroundColor: "transparent",
    height: dynamicSize(55),
    borderRadius: dynamicSize(14),
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    borderWidth: 1,
    borderColor: "#E53935",
    gap: 8,
  },
  closeBtnText: {
    color: "#E53935",
    fontSize: dynamicFontSize(15),
    fontFamily: "Sen-Bold",
  },

  // Add these to your StyleSheet.create object:
  disabledBtn: {
    backgroundColor: "#E0E0E0", // Muted grey background
    borderColor: "#CCCCCC",
  },
  disabledText: {
    color: "#A0A0A0", // Faded text color
  },
  disabledRevisitBtn: {
    borderColor: "#E0E0E0",
    backgroundColor: "#F5F5F5",
  },
  disabledRevisitText: {
    color: "#A0A0A0",
  },
});

// import React, { useContext, useEffect, useRef, useState } from "react";
// import {
//   StyleSheet,
//   Text,
//   View,
//   TouchableOpacity,
//   ActivityIndicator,
//   SafeAreaView,
//   ScrollView,
//   Dimensions,
//   PixelRatio,
// } from "react-native";
// import { MaterialCommunityIcons } from "@expo/vector-icons";
// import Colours from "../../utils/Colours";
// import AppContext from "../../context/AppContext";
// import useAxiosPrivate from "../../hooks/useAxiosPrivate";
// import socketConfig from "../../utils/socketConfig";
// import useAuth from "../../hooks/useAuth";

// const { width, height } = Dimensions.get("window");
// const BASE_WIDTH = 375;
// const BASE_HEIGHT = 812;

// const dynamicFontSize = (size) => {
//   const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
//   return Math.round(PixelRatio.roundToNearestPixel(size * scaleFactor));
// };
// const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;
// const dynamicSize = (size) => (width / BASE_WIDTH) * size;

// //   const amount = auth?.pendingOrderDetails?.amount || 0;
// //   const checkoutUrl = auth?.pendingOrderDetails?.checkoutUrl;

// //   // Initialize state directly from localStorage synchronously
// //   const [loading, setLoading] = useState(() => {
// //     if (typeof window !== "undefined") {
// //       const wasRedirected = localStorage.getItem("monnify_redirected");
// //       return wasRedirected !== "true";
// //     }
// //     return true;
// //   });

// //   const [userReturned, setUserReturned] = useState(() => {
// //     if (typeof window !== "undefined") {
// //       return localStorage.getItem("monnify_redirected") === "true";
// //     }
// //     return false;
// //   });

// //   // 1. Safe Auto-redirect hook (Fixed Logic)
// //   useEffect(() => {
// //     if (!checkoutUrl) {
// //       setLoading(false);
// //       setUserReturned(true);
// //       return;
// //     }

// //     // CRITICAL: Read directly from localStorage here, do not rely on state variables
// //     const wasRedirected = localStorage.getItem("monnify_redirected");

// //     if (wasRedirected === "true") {
// //       // The user hit the back button! Stop everything and let them rest here.
// //       setLoading(false);
// //       setUserReturned(true);
// //     } else {
// //       // First time landing here: set the flag immediately and redirect
// //       localStorage.setItem("monnify_redirected", "true");
// //       setLoading(true);
// //       window.location.href = checkoutUrl;
// //     }
// //   }, [checkoutUrl]); // Only re-run if the checkout URL itself changes

// //   // 2. Tab/Window Focus Hook
// //   useEffect(() => {
// //     if (typeof window === "undefined") return;

// //     const handleTabFocus = () => {
// //       const wasRedirected = localStorage.getItem("monnify_redirected");
// //       if (wasRedirected === "true") {
// //         setLoading(false);
// //         setUserReturned(true);
// //       }
// //     };

// //     window.addEventListener("focus", handleTabFocus);
// //     document.addEventListener("visibilitychange", () => {
// //       if (document.visibilityState === "visible") handleTabFocus();
// //     });

// //     return () => {
// //       window.removeEventListener("focus", handleTabFocus);
// //     };
// //   }, []);

// //   // 3. Update Close action
// //   const handleClose = () => {
// //     localStorage.removeItem("monnify_redirected");
// //     setAuth((prev) => ({
// //       ...prev,
// //       hasPendingPrepaidOrder: false,
// //       pendingOrderDetails: null,
// //     }));
// //   };

// //   // 4. Update Retry action
// //   const handlePayAgain = () => {
// //     if (checkoutUrl) {
// //       setLoading(true);
// //       localStorage.setItem("monnify_redirected", "true");
// //       window.location.href = checkoutUrl;
// //     }
// //   };

// const PayForTable = () => {
//   const { auth, setAuth } = useContext(AppContext);
//   const { sub } = useAuth();

//   const [isPayAgain, setIsPayAgain] = useState(false);
//   const [isClosing, setIsClosing] = useState(false);
//   const hasRedirected = useRef(false);
//   const axiosPrivate = useAxiosPrivate();

//   const amount = auth?.pendingOrderDetails?.amount || 0;
//   const checkoutUrl = auth?.pendingOrderDetails?.checkoutUrl;

//   // Replace your old useRef declaration with this logic:
//   const [loading, setLoading] = useState(() => {
//     // Check if we already tried redirecting in this browser session
//     if (typeof window !== "undefined") {
//       const wasRedirected = sessionStorage.getItem("monnify_redirected");
//       return wasRedirected !== "true"; // Keep loading True if we haven't left yet
//     }
//     return true;
//   });

//   const [userReturned, setUserReturned] = useState(() => {
//     if (typeof window !== "undefined") {
//       return sessionStorage.getItem("monnify_redirected") === "true";
//     }
//     return false;
//   });

//   // 1. Safe Auto-redirect hook
//   useEffect(() => {
//     if (!checkoutUrl) {
//       setLoading(false);
//       setUserReturned(true);
//       return;
//     }

//     const wasRedirected = sessionStorage.getItem("monnify_redirected");

//     // ONLY redirect if we haven't marked this session as redirected yet
//     if (wasRedirected !== "true") {
//       sessionStorage.setItem("monnify_redirected", "true");
//       setLoading(true);
//       window.location.href = checkoutUrl;
//     } else {
//       // If the flag is true, they hit the back button to get here!
//       setLoading(false);
//       setUserReturned(true);
//     }
//   }, [checkoutUrl]);

//   // 2. Tab/Window Focus Hook (Optional clean up helper)
//   useEffect(() => {
//     if (typeof window === "undefined") return;

//     const handleTabFocus = () => {
//       const wasRedirected = sessionStorage.getItem("monnify_redirected");
//       if (wasRedirected === "true") {
//         setLoading(false);
//         setUserReturned(true);
//       }
//     };

//     window.addEventListener("focus", handleTabFocus);
//     document.addEventListener("visibilitychange", () => {
//       if (document.visibilityState === "visible") handleTabFocus();
//     });

//     return () => {
//       window.removeEventListener("focus", handleTabFocus);
//       document.removeEventListener("visibilitychange", handleTabFocus);
//     };
//   }, []);

//   // 3. Update Close action to clean up the session key
//   const handleClose = async () => {
//     // 1. Clear the session storage flag locally
//     setIsClosing(true);
//     setLoading(true);

//     sessionStorage.removeItem("monnify_redirected");
//     sessionStorage.removeItem("is_topup_flow");

//     try {
//       // 2. Make the API request to update the database using axiosPrivate
//       // Adjust the payload if your backend expects a different structure (e.g., orderId)
//       await axiosPrivate.post("cancelPendingOrders/cancelPendingOrders");

//       console.log("Database successfully reset for pending order.");
//     } catch (error) {
//       console.error("Failed to reset pending order in the database:", error);
//       // Optional: You can add user-facing error notifications here (like a toast alert)
//     } finally {
//       // 3. Clear local state so the UI updates immediately
//       setAuth((prev) => ({
//         ...prev,
//         hasPendingPrepaidOrder: false,
//         pendingOrderDetails: null,
//       }));
//       setLoading(false);
//     }
//   };

//   // 4. Update Retry action to override session variable
//   const handlePayAgain = () => {
//     if (checkoutUrl) {
//       setIsPayAgain(true);
//       setLoading(true);
//       sessionStorage.setItem("monnify_redirected", "true"); // keep track
//       window.location.href = checkoutUrl;
//     }
//   };

//   return (
//     <SafeAreaView style={styles.container}>
//       {/* HEADER */}
//       <View style={styles.header}>
//         <Text style={styles.headerTitle}>Secure Checkout</Text>
//       </View>

//       <ScrollView contentContainerStyle={styles.scrollContent}>
//         {/* BILLING SUMMARY CARD */}
//         <View style={styles.summaryCard}>
//           <View style={styles.row}>
//             <Text style={styles.label}>Order Amount</Text>
//             <Text style={styles.value}>₦{amount.toLocaleString()}</Text>
//           </View>

//           <View style={styles.row}>
//             <Text style={styles.label}>Service Charge</Text>
//             <Text style={styles.value}>₦0.00</Text>
//           </View>

//           <View style={[styles.row, { marginTop: 10 }]}>
//             <Text style={styles.totalLabel}>Total to Pay</Text>
//             <Text style={styles.totalValue}>₦{amount.toLocaleString()}</Text>
//           </View>
//         </View>

//         {/* INFO NOTICE */}
//         <View style={styles.infoBox}>
//           <MaterialCommunityIcons name="shield-check" size={20} color={Colours.PRIMARY} />
//           <Text style={styles.infoText}>
//             Your payment is secured by Monnify by Moniepoint and Paystack our payment processing
//             partners.
//           </Text>
//         </View>

//         {userReturned && !loading && (
//           <Text style={styles.returnNotice}>
//             Transaction was uncompleted. Would you like to retry or cancel?
//           </Text>
//         )}
//       </ScrollView>

//       {/* FOOTER CONTROLS */}
//       <View style={styles.footer}>
//         {loading ? (
//           <View style={styles.loaderContainer}>
//             <ActivityIndicator size="large" color={Colours.PRIMARY} />
//             <Text style={styles.loaderText}>
//               {isPayAgain
//                 ? "Connecting to payment gateway..."
//                 : isClosing
//                   ? "Canceling..."
//                   : "Connecting to payment gateway..."}
//             </Text>
//           </View>
//         ) : (
//           <View style={styles.actionBlock}>
//             <TouchableOpacity style={styles.payBtn} onPress={handlePayAgain}>
//               <Text style={styles.payBtnText}>Pay ₦{amount.toLocaleString()}</Text>
//               <MaterialCommunityIcons name="lock-outline" size={20} color="white" />
//             </TouchableOpacity>

//             <TouchableOpacity style={styles.closeBtn} onPress={handleClose}>
//               <Text style={styles.closeBtnText}>Cancel & Close</Text>
//               <MaterialCommunityIcons name="close-circle-outline" size={20} color="#E53935" />
//             </TouchableOpacity>
//           </View>
//         )}
//       </View>
//     </SafeAreaView>
//   );
// };

// export default PayForTable;

// const styles = StyleSheet.create({
//   container: {
//     flex: 1,
//     backgroundColor: Colours.LIGHTEST,
//   },
//   header: {
//     alignItems: "center",
//     paddingHorizontal: dynamicSpacing(20),
//     paddingVertical: dynamicSpacing(15),
//   },
//   headerTitle: {
//     fontSize: dynamicFontSize(18),
//     fontFamily: "Sen-Bold",
//     color: Colours.DARKGRAY,
//   },
//   scrollContent: {
//     paddingHorizontal: dynamicSpacing(20),
//     paddingTop: dynamicSpacing(10),
//   },
//   summaryCard: {
//     backgroundColor: "white",
//     borderRadius: dynamicSize(24),
//     padding: dynamicSpacing(25),
//     borderWidth: 1,
//     borderColor: "#F2F2F2",
//   },
//   row: {
//     flexDirection: "row",
//     justifyContent: "space-between",
//     marginBottom: dynamicSpacing(12),
//   },
//   label: {
//     fontSize: dynamicFontSize(14),
//     fontFamily: "Sen-Regular",
//     color: Colours.DARKLIGHTGRAY,
//   },
//   value: {
//     fontSize: dynamicFontSize(14),
//     fontFamily: "Sen-Bold",
//     color: Colours.DARKGRAY,
//   },
//   totalLabel: {
//     fontSize: dynamicFontSize(16),
//     fontFamily: "Sen-Bold",
//     color: Colours.DARKGRAY,
//   },
//   totalValue: {
//     fontSize: dynamicFontSize(20),
//     fontFamily: "Sen-Bold",
//     color: Colours.PRIMARY,
//   },
//   infoBox: {
//     flexDirection: "row",
//     backgroundColor: "#F0F7FF",
//     padding: dynamicSpacing(15),
//     borderRadius: dynamicSize(15),
//     marginTop: dynamicSpacing(25),
//     alignItems: "center",
//   },
//   infoText: {
//     flex: 1,
//     fontSize: dynamicFontSize(12),
//     fontFamily: "Sen-Regular",
//     color: "#4A6E91",
//     marginLeft: 10,
//     lineHeight: 18,
//   },
//   returnNotice: {
//     color: "#777",
//     fontSize: dynamicFontSize(13),
//     fontFamily: "Sen-Regular",
//     textAlign: "center",
//     marginTop: dynamicSpacing(25),
//     paddingHorizontal: 10,
//   },
//   footer: {
//     padding: dynamicSpacing(20),
//     backgroundColor: "white",
//     borderTopWidth: 1,
//     borderTopColor: "#F2F2F2",
//   },
//   loaderContainer: {
//     alignItems: "center",
//     paddingVertical: 10,
//   },
//   loaderText: {
//     marginTop: 10,
//     color: Colours.DARKGRAY,
//     fontFamily: "Sen-Medium",
//     fontSize: dynamicFontSize(14),
//   },
//   actionBlock: {
//     gap: 12,
//   },
//   payBtn: {
//     backgroundColor: Colours.PRIMARY,
//     height: dynamicSize(55),
//     borderRadius: dynamicSize(14),
//     flexDirection: "row",
//     justifyContent: "center",
//     alignItems: "center",
//     gap: 8,
//   },
//   payBtnText: {
//     color: "white",
//     fontSize: dynamicFontSize(15),
//     fontFamily: "Sen-Bold",
//   },
//   closeBtn: {
//     backgroundColor: "transparent",
//     height: dynamicSize(55),
//     borderRadius: dynamicSize(14),
//     flexDirection: "row",
//     justifyContent: "center",
//     alignItems: "center",
//     borderWidth: 1,
//     borderColor: "#E53935",
//     gap: 8,
//   },
//   closeBtnText: {
//     color: "#E53935",
//     fontSize: dynamicFontSize(15),
//     fontFamily: "Sen-Bold",
//   },
// });
